import { AfterViewChecked, AfterViewInit, Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatDrawer } from '@angular/material/sidenav';
import { MatTable } from '@angular/material/table';
import { MatTabGroup } from '@angular/material/tabs';
import { TooltipPosition } from '@angular/material/tooltip';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from "@angular/router";
import { ConfirmationDialogComponent, ConfirmationDialogModel } from '../../dialogs/confirmation/confirmation-dialog.component';
import { FormFieldConstraintTypeEnum } from '../../enums/form-field-constraint-type.enum';
import { IFormFieldConstraint, IFormFieldConstraintWithMetrics } from '../../interfaces/iform-field-constraint.interface';
import { CascadingDropDownFormFieldConfig } from '../../models/cascading-dropdown/cascading-dropdown-config.model';
import { SiteFormFieldConstraintProperties } from '../../models/form-builder/field-constraints/site-form-field-constraint-props.model';
import { FormFieldPropertyEnum } from '../../models/form-builder/form-field-property-enum.model';
import { FormField } from '../../models/form-builder/form-field.model';
import { Form } from '../../models/form-builder/form.model';
import { CurrentSiteService } from '../../services/current-site.service';
import { CachedFormFieldService } from '../../services/form-field-with-cache.service';
import { FormFieldService } from '../../services/form-field.service';
import { FormFieldCascadingDropdownConstraintLiaison } from '../form-builder/properties/form-field-properties/constraints/field-cascading-dropdown-constraint-liaison';
import { FormFieldCascadingListValueConstraintLiaison } from '../form-builder/properties/form-field-properties/constraints/field-cascading-list-values-constraint-liaison';
import { FormFieldDateRangeConstraintLiaison } from '../form-builder/properties/form-field-properties/constraints/field-date-range-constraint-liaison';
import { FormFieldNumericRangeConstraintLiaison } from '../form-builder/properties/form-field-properties/constraints/field-numeric-range-constraint-liaison';
import { FormFieldRegularExpressionConstraintLiaison } from '../form-builder/properties/form-field-properties/constraints/field-regular-expression-constraint-liaison';
import { FormFieldSelectOptionsConstraintLiaison } from '../form-builder/properties/form-field-properties/constraints/field-select-options-constraint-liaison';
import { FormFieldSimpleListValueConstraintLiaison } from '../form-builder/properties/form-field-properties/constraints/field-simple-list-values-constraint-liaison';
import { IFormFieldConstraintLiaison } from '../form-builder/properties/form-field-properties/constraints/ifield-constraint-liason.interface';
import { ScriptableBaseComponent } from '../scriptable-base/scriptable-base.component';

// Define an internally used class.
class FormFieldConstraintsTabData {
    // Tab name.
    public tabName: string;
    public basicPropertiesExpanded: boolean;

    // Constraint-related properties.
    public constraintsRetrieved: boolean = false;
    public constraintType: string;
    //public retrieveConstraintsMethodName: string;
    public constraints: IFormFieldConstraintWithMetrics[] = [];

    // Property name for interacting with the form field properties component.
    public formFieldPropertyNames: string[];

    // A constraint 'liaison' for this type of constraint.
    public constraintLiaison: IFormFieldConstraintLiaison;

    // UI-related properties.
    public table: MatTable<IFormFieldConstraintWithMetrics>;
}
// Define an internally used enumeration.
enum ConstraintsTabIndexEnum {
    SimpleListValuesTab = 0,
    CascadingLIstValuesTab = 1,

    ListOptionsTab = 2,
    RegularExpressionsTab = 3,
    CascadingDropdownsTab = 4,
    NumericRangesTab = 5,
    DateRangesTab = 6
}

// Define internally used, type-safe dictionary/hash/map interfaces.
interface IConstrainatTypeToTabData {
    [constraintType: string]: FormFieldConstraintsTabData;
}

// Define a class containing properties used to interact with the
// form field properties (<app-form-field-properties/>) component.
class FormFieldPropertiesData {
    public dummyFormField: FormField;
    public dummyForm: Form = null;
    public selectedFieldPropertyNames: string[] = [];
    public selectedFieldConstraintNames: string[] = [];
    public customRegexConstraintName: string = null;
}

class ConstraintMaps {
    public constraintsTables: MatTable<IFormFieldConstraintWithMetrics>[] = null;
    public constraintTableElementRefs: ElementRef[] = null;
}

class ConstraintUIResources {
    public constraintsTables: MatTable<IFormFieldConstraintWithMetrics>[] = null;
    public constraintTableElementRefs: ElementRef[] = null;
}

// @Component({
//     selector: 'app-form-field-constraints',
//     templateUrl: './form-field-constraints.component.html?v=${new Date().getTime()}',
//     styleUrls: ['./form-field-constraints.component.scss?v=${new Date().getTime()}']
//     //encapsulation: ViewEncapsulation.
// })

//Kevin
@Component({
    selector: 'app-form-field-constraints',
    templateUrl: './form-field-constraints.component.html',
    styleUrls: ['./form-field-constraints.component.scss']
    //encapsulation: ViewEncapsulation.
    ,
    standalone: false
})
export class FormFieldConstraintsComponent extends ScriptableBaseComponent implements OnInit, AfterViewInit, AfterViewChecked {
    // Properties.
    @ViewChild('matTabGroup') tabGroup: MatTabGroup;
    private tabGroupIndex: number = 0;
    private constraintsAreEditable = false;

    private readonly tabData: FormFieldConstraintsTabData[] =
        [
            {
                tabName: 'Simple List Values',
                basicPropertiesExpanded: true,
                constraintsRetrieved: false,
                constraintType: FormFieldConstraintTypeEnum.SimpleListValues,
                constraints: [],
                formFieldPropertyNames: ['selectOptionsProperty'],
                constraintLiaison: new FormFieldSimpleListValueConstraintLiaison(),
                table: null
            },
            {
                tabName: 'Cascading List Values',
                basicPropertiesExpanded: true,
                constraintsRetrieved: false,
                constraintType: FormFieldConstraintTypeEnum.CascadingListValues,
                constraints: [],
                formFieldPropertyNames: ['selectOptionsFileProperty'],
                constraintLiaison: new FormFieldCascadingListValueConstraintLiaison(),
                table: null
            },
            {
                tabName: 'List Options',
                basicPropertiesExpanded: true,
                constraintsRetrieved: false,
                constraintType: FormFieldConstraintTypeEnum.SelectOptions,
                constraints: [],
                formFieldPropertyNames: ['selectOptionsProperty'],
                constraintLiaison: new FormFieldSelectOptionsConstraintLiaison(),
                table: null
            },
            {
                tabName: 'Regular Expressions',
                basicPropertiesExpanded: false,
                constraintsRetrieved: false,
                constraintType: FormFieldConstraintTypeEnum.RegularExpression,
                constraints: [],
                formFieldPropertyNames: ['regexProperty'],
                constraintLiaison: new FormFieldRegularExpressionConstraintLiaison(),
                table: null
            },
            {
                tabName: 'Cascading Dropdowns',
                basicPropertiesExpanded: false,
                constraintsRetrieved: false,
                constraintType: FormFieldConstraintTypeEnum.CascadingDropdown,
                constraints: [],
                formFieldPropertyNames: ['selectOptionsFileProperty'],
                constraintLiaison: new FormFieldCascadingDropdownConstraintLiaison(),
                table: null
            },
            {
                tabName: 'Numeric Ranges',
                basicPropertiesExpanded: true,
                constraintsRetrieved: false,
                constraintType: FormFieldConstraintTypeEnum.NumericRange,
                constraints: [],
                formFieldPropertyNames: ['minValueProperty', 'maxValueProperty'],
                constraintLiaison: new FormFieldNumericRangeConstraintLiaison(),
                table: null
            },
            {
                tabName: 'Date Ranges',
                basicPropertiesExpanded: true,
                constraintsRetrieved: false,
                constraintType: FormFieldConstraintTypeEnum.DateRange,
                constraints: [],
                formFieldPropertyNames: ['minDateProperty', 'maxDateProperty'],
                constraintLiaison: new FormFieldDateRangeConstraintLiaison(),
                table: null
            },
        ];
    private mapOfTabData: IConstrainatTypeToTabData = {};

    //private mapOfConstraintLiaisons: IConstraintTypeToConstraintLiaison = {};

    @ViewChildren(MatTable, { read: MatTable }) matTables: QueryList<MatTable<IFormFieldConstraintWithMetrics>>;
    @ViewChildren(MatTable, { read: ElementRef }) matTableElementRefs: QueryList<ElementRef>;
    @ViewChild('drawer') drawer: MatDrawer;
    private constraintsTables: MatTable<IFormFieldConstraintWithMetrics>[] = null;
    private constraintTableElementRefs: ElementRef[] = null;

    private selectedConstraint: IFormFieldConstraint = null;
    private selectedConstraintFieldData: FormFieldPropertiesData = null;

    // Constructor.
    public constructor(private formFieldService: FormFieldService,
        private cachedFormFieldService: CachedFormFieldService,
        private currentSiteService: CurrentSiteService,
        private dialog: MatDialog,
        private readonly titleService: Title,
        private route: ActivatedRoute,
        //componentHierarchyService: ComponentHierarchyService,
        elForBaseClass: ElementRef) {
        //super(componentHierarchyService, elForBaseClass);
        super(elForBaseClass);

        this.mapOfTabData[FormFieldConstraintTypeEnum.SimpleListValues] = this.tabData[ConstraintsTabIndexEnum.SimpleListValuesTab]
        this.mapOfTabData[FormFieldConstraintTypeEnum.CascadingListValues] = this.tabData[ConstraintsTabIndexEnum.CascadingLIstValuesTab];

        this.mapOfTabData[FormFieldConstraintTypeEnum.SelectOptions] = this.tabData[ConstraintsTabIndexEnum.ListOptionsTab];
        this.mapOfTabData[FormFieldConstraintTypeEnum.RegularExpression] = this.tabData[ConstraintsTabIndexEnum.RegularExpressionsTab];
        this.mapOfTabData[FormFieldConstraintTypeEnum.CascadingDropdown] = this.tabData[ConstraintsTabIndexEnum.CascadingDropdownsTab];
        this.mapOfTabData[FormFieldConstraintTypeEnum.NumericRange] = this.tabData[ConstraintsTabIndexEnum.NumericRangesTab];
        this.mapOfTabData[FormFieldConstraintTypeEnum.DateRange] = this.tabData[ConstraintsTabIndexEnum.DateRangesTab];
    }

    // Life cycle methods.
    public ngOnInit(): void {
        super.ngOnInit();

        this.retrieveAllSiteNamedConstraints();
        this.titleService.setTitle(this.route.snapshot.data['title'] + ' for ' + this.currentSiteService.Site.name);
    }

    public ngAfterViewInit(): void {
        if (this.matTables != null) {
            this.constraintsTables = this.matTables.toArray();
            this.constraintTableElementRefs = this.matTableElementRefs.toArray();
        }

        return;
    }

    public ngAfterViewChecked(): void {
        if (this.tabGroup != null)
            this.tabGroup.realignInkBar();
    }
    // Begin methods called by my HTML code.
    public get TabGroupSelectedIndex(): number {
        return this.tabGroupIndex;
    }
    public set TabGroupSelectedIndex(value: number) {
        this.tabGroupIndex = value;
    }

    public getMatTabStyle(tabIndex: number): string {
        let style: string = '';

        if (tabIndex == this.tabGroupIndex)
            style += 'font-weight: 900 !important; opacity: 1.0 !important;';

        return style;
    }

    public get TabNames(): string[] {
        let tabNames: string[] = this.tabData.map(td => td.tabName);
        return tabNames;
    }
    public IsSelectectTab(tabIndex: number): boolean {
        return tabIndex == this.tabGroupIndex;
    }
    public get BasicPropertiesExpanded(): boolean {
        let selectedTab: FormFieldConstraintsTabData = this.tabData[this.tabGroupIndex];
        return selectedTab.basicPropertiesExpanded;
    }

    public ColumnIsSticky(columnName: string): boolean {
        return true; // Hard wired for now.
    }
    public get ConstraintsTableColumnNames(): string[] {
        return ['constraintName', 'constraintExpression', 'constraintUseCount', 'constraintActions', 'addConstraintAction'];
    }
    public get HeaderRowIsSticky(): boolean {
        return true;
    }

    public getConstraintExprSummary(constraint: IFormFieldConstraintWithMetrics): string {
        return constraint.constraintExpressionSummary;
    }
    public ConstraintsListing(tabIndex: number): IFormFieldConstraintWithMetrics[] {
        return this.tabData[tabIndex].constraints;
    }
    public ConstraintUseCount(constraint: IFormFieldConstraintWithMetrics): number {
        return constraint.useCount;
    }

    public get EditConstraintButtonDisabled(): boolean {
        return !this.constraintsAreEditable;
    }
    public TrashCanButtonDisabled(constraint: IFormFieldConstraintWithMetrics): boolean {
        return (this.ConstraintUseCount(constraint) > 0);
    }
    public get AddConstraintButtonDisabled(): boolean {
        return false;
    }

    public get EditConstraintTooltip(): string {
        return 'Edit this constraint';
    }
    public TrashCanTooltip(constraint: IFormFieldConstraintWithMetrics): string {
        let tooltip: string = 'Delete this constraint';

        let useCount: number = this.ConstraintUseCount(constraint);
        if (useCount > 0) {
            tooltip = 'Delete this constraint (this constraint cannot be deleted because it is in use by ';
            if (useCount == 1)
                tooltip += 'one form field)';
            else
                tooltip += `${useCount} form fields)`;
        }

        return tooltip;
    }
    public get AddConstraintTooltip(): string {
        return 'Add a new constraint';
    }
    public get TooltipPosition(): TooltipPosition {
        let position: TooltipPosition = 'below';

        return (position);
    }

    public get SelectedConstraint(): IFormFieldConstraint {
        return this.selectedConstraint;
    }
    public get SelectedField(): FormField {
        return (this.selectedConstraintFieldData != null ? this.selectedConstraintFieldData.dummyFormField : null);
    }
    public get SelectedFieldPropertyNames(): string[] {
        return (this.selectedConstraintFieldData != null ? this.selectedConstraintFieldData.selectedFieldPropertyNames : []);
    }
    public get SelectedFieldConstraintNames(): string[] {
        return (this.selectedConstraintFieldData != null ? this.selectedConstraintFieldData.selectedFieldConstraintNames : []);
    }
    public get CustomRegexConstraintName(): string {
        return (this.selectedConstraintFieldData != null ? this.selectedConstraintFieldData.customRegexConstraintName : null);
    }
    public get SelectedFieldDisplayFormatValues(): string[] {
        return [];
    }
    public get SelectedFieldDisplayRowsValues(): string[] {
        return [];
    }
    public get SelectedForm(): Form {
        return (this.selectedConstraintFieldData != null ? this.selectedConstraintFieldData.dummyForm : null);
    }

    public get BetaFeaturesEnabled(): boolean {
        return this.currentSiteService.Site.betaFeaturesEnabled;
    }
    // End methods called by my HTML code.

    // Begin control event handling methods.
    public tabChanged(): void {
        return;
    }

    public editConstraint(constraint: IFormFieldConstraintWithMetrics): void {
        //let constraintType: string = constraint.type;
        //let tabData: FormFieldConstraintsTabData = this.mapOfTabData[constraintType];
        let tabData: FormFieldConstraintsTabData = this.getTabDataForConstraint(constraint);

        if (tabData != null) {
            let dataCollectionId: number = this.currentSiteService.Site.id;
            this.selectedConstraintFieldData = FormFieldConstraintsComponent.createConstraintFieldProperties(constraint, dataCollectionId, tabData);

            this.selectedConstraint = constraint;

            this.drawer.open();
        }
    }
    public deleteConstraint(constraint: IFormFieldConstraintWithMetrics): void {
        let dialogData: ConfirmationDialogModel = new ConfirmationDialogModel('Delete Constraint', `Delete constraint '${constraint.name}'?`);
        let dialogConfig = { width: '400px', data: dialogData };
        let dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);

        dialogRef.afterClosed().subscribe(yes => {
            if (yes) {
                this.formFieldService.deleteNamedConstraint(constraint.id).then(deletedConstraint => {
                    if (deletedConstraint != null) {
                        // Remove the deleted constraint.
                        let constraintType: string = constraint.type;
                        let tabData: FormFieldConstraintsTabData = this.mapOfTabData[constraintType];
                        if (tabData != null) {
                            tabData.constraints = tabData.constraints.filter(c => c.id != constraint.id);
                        }

                        // Clear the form field constraints cache.
                        this.cachedFormFieldService.clearCache();
                    }
                });
            }
        });
    }
    public addNewConstraint(): void {
        // Ask the current's tab's constraint liaison to create a new constraint.
        let tabData: FormFieldConstraintsTabData = this.tabData[this.tabGroupIndex];
        let newConstraint: IFormFieldConstraintWithMetrics = tabData.constraintLiaison.createNewConstraint(this.currentSiteService.Site.id);

        // Edit this new constraint.
        this.editConstraint(newConstraint);
    }
    public closeFieldPropertiesDrawer(applyChanges: boolean): void {
        this.drawer.close();

        if (applyChanges) {
            let constraintType: string = this.selectedConstraint.type;
            //let constraintLiaison: IFormFieldConstraintLiaison = this.mapOfConstraintLiaisons[constraintType];
            let tabData: FormFieldConstraintsTabData = this.mapOfTabData[constraintType];

            //if (constraintLiaison != null) {
            if (tabData != null) {
                let constraintName: string = tabData.constraintLiaison.getConstraintName(this.selectedConstraintFieldData.dummyFormField);
                let constraintPropertyValue: string = tabData.constraintLiaison.getConstraintFormFieldPropertyValue(this.selectedConstraintFieldData.dummyFormField);
                let constraintFailureMessage: string = tabData.constraintLiaison.getConstraintFailureMessage(this.selectedConstraintFieldData.dummyFormField);

                this.selectedConstraint.name = constraintName;
                this.selectedConstraint.constraintExpression = constraintPropertyValue;
                this.selectedConstraint.constraintFailureMessage = constraintFailureMessage;

                if ((this.selectedConstraint.id == null) || (this.selectedConstraint.id == 0)) {
                    // Create a new constraint.
                    let createMethodName: string = tabData.constraintLiaison.createNamedConstraintMethodName;
                    this.formFieldService[createMethodName](this.selectedConstraint).then(createdConstraint => {
                        if (createdConstraint != null) {
                            let constraintWithMetrics = tabData.constraintLiaison.createNewConstraintFrom(createdConstraint);
                            // Add the new constraint to the list of constraints of this type.
                            //tabData.constraints.push(createdConstraint);
                            tabData.constraints.push(constraintWithMetrics);
                            if (tabData.table != null)
                                tabData.table.renderRows();

                            // Clear the form field constraints cache.
                            this.cachedFormFieldService.clearCache();
                        }
                    });
                } else {
                    // Update an existing constraint.
                    let updateMethodName: string = tabData.constraintLiaison.updateNamedConstraintMethodName;
                    this.formFieldService[updateMethodName](this.selectedConstraint).then(updatedConstraint => {
                        if (updatedConstraint != null) {
                            // Clear the form field constraints cache.
                            this.cachedFormFieldService.clearCache();
                        }
                    });
                }
            }
        }

        this.selectedConstraintFieldData = null;
        this.selectedConstraint = null;
    }
    public fieldPropertyChanged(eventData: any): void {
        if ((eventData.propertyName == FormFieldPropertyEnum.SELECT_OPTIONS_FILE) || (eventData.propertyName == FormFieldPropertyEnum.SELECTED_CASCADING_DROPDOWN_CONSTRAINT)) {
            let formField: FormField = eventData.formField;
            if (formField.csvOptionsData) {
                this.selectedConstraintFieldData.dummyFormField.csvOptionsData = formField.csvOptionsData;
            }
        }
    }

    public drawerClosing(): void {

    }
    // End control event handling methods.

    // Helper methods.
    /*
    private retrieveConstraints(tabIndex: number): void {
        if (!this.tabData[tabIndex].constraintsRetrieved) {
            //this.tabData[tabIndex].retrievalServiceMethod(this.currentSiteService.Site.id).then(siteConstraints => {
            let methodName: string = this.tabData[tabIndex].retrieveConstraintsMethodName;
            let dataCollectionId: number = this.currentSiteService.Site.id;
            this.formFieldService[methodName](dataCollectionId).then(siteConstraints => {
                this.tabData[tabIndex].constraints = siteConstraints;
            });
        }
    }
    */

    private retrieveAllSiteNamedConstraints(): void {
        let dataCollectionId: number = this.currentSiteService.Site.id;
        this.formFieldService.getAllSiteNamedConstraints(dataCollectionId).then(allConstraints => {
            if ((allConstraints != null) && (allConstraints.length > 0)) {
                this.constraintsAreEditable = allConstraints[0].editable; // if one is editable/uneditable, they all are

                for (let index: number = 0; index < allConstraints.length; index++) {
                    let constraintProperties: SiteFormFieldConstraintProperties = allConstraints[index];

                    /*
                    let tabData: FormFieldConstraintsTabData = this.mapOfTabData[constraintProperties.constraintType];

                    if ((tabData == null) && (constraintProperties.constraintType == 'ListValues')) {
                        // Note:  list value constraints cannot be identified by their type alone.
                        if ((constraintProperties.selectOptionsValue != null) && (constraintProperties.selectOptionsValue.trim() != ''))
                            tabData = this.mapOfTabData[FormFieldConstraintTypeEnum.SimpleListValues];
                        else if ((constraintProperties.jsonConfig != null) && (constraintProperties.jsonConfig.trim() != ''))
                            tabData = this.mapOfTabData[FormFieldConstraintTypeEnum.CascadingListValues];
                    }

                    if (tabData == null)
                        throw `FormFieldConstraintsComponent.retrieveAllSitNamedConstraints():  cannot find metadata for a constraint of type '${constraintProperties.constraintType}'.`
                    */
                    let tabData: FormFieldConstraintsTabData = this.getTabDataForConstraintProperties(constraintProperties);

                    // Ask the constraint laison to unpack this constraint
                    // properties record to (re)create the form field constraint.
                    let constraint: IFormFieldConstraintWithMetrics = tabData.constraintLiaison.createFromConstraintProperties(dataCollectionId, constraintProperties);
                    tabData.constraints.push(constraint);
                }

                if (this.constraintsTables != null) {
                    for (let index: number = 0; index < this.constraintsTables.length; index++) {
                        let constraintsTable: MatTable<IFormFieldConstraintWithMetrics> = this.constraintsTables[index];
                        let tableElementRef: ElementRef = this.constraintTableElementRefs[index];

                        let tabIndex: number = parseInt(tableElementRef.nativeElement.id.replace('table-', ''));
                        this.tabData[tabIndex].table = constraintsTable;

                        constraintsTable.renderRows();
                    }
                }
            }
        });
    }

    private static createConstraintFieldProperties(constraint: IFormFieldConstraintWithMetrics, dataCollectionId: number, tabData: FormFieldConstraintsTabData): FormFieldPropertiesData {
        let formFieldProperties: FormFieldPropertiesData = new FormFieldPropertiesData();

        formFieldProperties.dummyFormField = new FormField();
        formFieldProperties.dummyFormField.id = 1; // This makes the form field look like it has been saved.
        tabData.constraintLiaison.applyConstraintPropertiesToFormField(constraint, formFieldProperties.dummyFormField);
        let usingFormFieldClasses: string[] = tabData.constraintLiaison.usedByFormFieldClasses;
        formFieldProperties.dummyFormField.fieldDefinitionClassName = usingFormFieldClasses[0];
        formFieldProperties.dummyFormField.name = tabData.constraintLiaison.constraintTypeForEndUser();
        formFieldProperties.dummyFormField.displayName = tabData.constraintLiaison.constraintTypeForEndUser();

        formFieldProperties.dummyForm = new Form();
        formFieldProperties.dummyForm.id = 1; // This makes the form look like it has been saved.

        formFieldProperties.dummyForm.dataCollectionId = dataCollectionId;
        formFieldProperties.selectedFieldPropertyNames = tabData.formFieldPropertyNames;

        return formFieldProperties;
    }

    private getTabDataForConstraintProperties(constraintProperties: SiteFormFieldConstraintProperties): FormFieldConstraintsTabData {
        let tabData: FormFieldConstraintsTabData = this.mapOfTabData[constraintProperties.constraintType];

        if ((tabData == null) && (constraintProperties.constraintType == 'ListValues')) {
            // Note:  list value constraints cannot be identified by their type alone.
            if ((constraintProperties.selectOptionsValue != null) && (constraintProperties.selectOptionsValue.trim() != ''))
                tabData = this.mapOfTabData[FormFieldConstraintTypeEnum.SimpleListValues];
            else if ((constraintProperties.jsonConfig != null) && (constraintProperties.jsonConfig.trim() != ''))
                tabData = this.mapOfTabData[FormFieldConstraintTypeEnum.CascadingListValues];
        }

        if (tabData == null)
            throw `FormFieldConstraintsComponent.retrieveAllSitNamedConstraints():  cannot find metadata for a constraint of type '${constraintProperties.constraintType}'.`

        return tabData;
    }

    private getTabDataForConstraint(constraint: IFormFieldConstraintWithMetrics): FormFieldConstraintsTabData {
        let tabData: FormFieldConstraintsTabData = this.mapOfTabData[constraint.type];

        return tabData;
    }
}
